export const UNIT_STATUSES_DE_BASIC = [
  { text: 'Available', value: 'new', name: 'new' },
  { text: 'Reserved', value: 'reserved', name: 'reserved' },
  { text: 'Booked', value: 'booked', name: 'booked' },
];
export const UNIT_STATUSES_DE_EXTRA = [
  { text: 'Delisted', value: 'delist', name: 'delist' },
  { text: 'Booked', value: 'sold_spa_signed', name: 'sold_spa_signed' },
  { text: 'Reserved', value: 'developer_reserved', name: 'developer_reserved' },
  { text: 'Booked', value: 'developer_booked', name: 'developer_booked' },
  { text: 'Booked', value: 'developer_sold', name: 'developer_sold' },
];
export const UNIT_STATUSES_DE_ALL = [
  ...UNIT_STATUSES_DE_BASIC,
  ...UNIT_STATUSES_DE_EXTRA,
];
export const UNIT_STATUSES_HQ_DEVELOPER = [
  { text: 'Reserved', value: 'developer_reserved', name: 'developer_reserved' },
  { text: 'Booked', value: 'developer_booked', name: 'developer_booked' },
  { text: 'Sold', value: 'developer_sold', name: 'developer_sold' },
];
export const UNIT_STATUSES_HQ_BASIC = [
  { text: 'Available', value: 'new', name: 'new' },
  { text: 'Reserved', value: 'reserved', name: 'reserved' },
  { text: 'Booked', value: 'booked', name: 'booked' },
  { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' },
  { text: 'Delisted', value: 'delist', name: 'delist' },
];
export const UNIT_STATUSES_SIMPLE_MODE = [
  { text: 'Available', value: 'new', name: 'new' },
  { text: 'Unavailable', value: 'unavailable', name: 'unavailable' },
];
export const UNIT_STATUSES_SIMPLE_ALL = [
  ...UNIT_STATUSES_HQ_BASIC,
  ...UNIT_STATUSES_SIMPLE_MODE,
];
export const UNIT_STATUSES_HQ_ALL = [
  ...UNIT_STATUSES_HQ_BASIC,
  ...UNIT_STATUSES_HQ_DEVELOPER,
];

export const UNIT_STATUSES_HQ_REAL = [
  { text: 'Available', value: 'new', name: 'new' },
  { text: 'Reserved', value: 'reserved', name: 'reserved' },
  { text: 'Booked', value: 'booked', name: 'booked' },
  { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' },
  { text: 'Delisted', value: 'delist', name: 'delist' },
  { text: 'Reserved outside MHub', value: 'developer_reserved', name: 'developer_reserved' },
  { text: 'Booked outside MHub', value: 'developer_booked', name: 'developer_booked' },
  { text: 'Sold outside MHub', value: 'developer_sold', name: 'developer_sold' },
];

export const UNIT_STATUSES_EXTERNAL_ALL = [
  { text: 'Available', value: 'new', name: 'new' },
  ...UNIT_STATUSES_HQ_DEVELOPER,
  { text: 'Delisted', value: 'delist', name: 'delist' },
];



// WEBPACK FOOTER //
// ./src/constants/unitStatuses.js